<template>
  <div>
    <ButtonGroup
      v-model="buttons"
      large
      @openRHorRODialog="showRHorRODialog = true"
    />

    <RHorRODialog v-model="showRHorRODialog" />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import ButtonGroup from "@/components/shared/buttons/ButtonGroup.vue";
import RHorRODialog from "@/components/aberration/new/children/RHorRODialog.vue";

export default Vue.extend({
  name: "DashboardButtons",
  data() {
    return {
      buttons: [
        {
          icon: "mdi-progress-wrench",
          btnText: "Nytt avvik",
          name: "Nytt avvik",
          to: "Aberration",
        },
        {
          icon: "mdi-alert-decagram-outline",
          btnText: "HMS-rapport",
          name: "HMS-rapport",
          // to: "RUH",
          emit: "openRHorRODialog",
        },
      ],
      showRHorRODialog: false,
    };
  },
  components: {
    ButtonGroup,
    RHorRODialog,
  },
});
</script>
